class CallSectionHandler {
  init(): void {
    // Select all cmp-call-section elements
    const callSections = document.querySelectorAll<HTMLDivElement>('.cmp-call-section');

    callSections.forEach((section) => {
      // Find the <a> element inside the current section
      const link = section.querySelector<HTMLAnchorElement>('a');

      // Check if the link exists and has an href attribute
      if (link?.href) {
        const href = link.href;

        // Add onclick to the cmp-call-section
        section.onclick = () => {
          window.location.href = href;
          trackAnalytics('click_cta', { innerText: 'call us now' }, 'button', 'modal');
        };
      }
    });
  }
}

function trackAnalytics(
  event: string,
  obj: { innerText: string },
  location: string,
  position: string
) {
  window.didomiOnReady = window.didomiOnReady || [];
  console.log('Didomi Wrapper trackAnalytics (cmpCallSection) - About to push callback');
  window.didomiOnReady.push(() => {
    console.log('Didomi Wrapper trackAnalytics (cmpCallSection) called - Didomi is ready');
    console.log('didomiVendorsEnabled =', window.didomiState?.didomiVendorsEnabled);
    const dataToLog = {
      event: event,
      click_main_name: obj.innerText,
      click_location: location,
      element_position: position,
    };
    console.log('Data to be pushed:', dataToLog);
    window.adobeDataLayer?.push(dataToLog);
    console.log('Custom event trackAnalytics pushed into the data layer');
  });
}

// Example usage
export const callSectionHandler = new CallSectionHandler();
callSectionHandler.init();
